export enum AttributeType {
  PRODUCTION_DATA = 'PRODUCTION_DATA',
  POTENTIAL = 'POTENTIAL',
  PROD_TEST_ATTR = 'PROD_TEST_ATTR',
  MONITORING_ATTR = 'MONITORING_ATTR',
  PROD_ALLOCATION = 'PROD_ALLOCATION',
}
